export const TagMixin = {
  data () {
    return {
      tagGroups: ['room', 'activity', 'facility', 'type']
    }
  }
}
